<template>
  <div class="panel has-bg">
    <h3>{{ $t('bearings.headlineEffects') }}</h3>
    <!-- Kraft -->
    <div class="row">
      <div class="col-sm-6">
        <b-form-group
          label-for="power"
        >
          <template slot="label">
            {{ $t('bearings.power') }} <span class="text-muted">F<sub>z,d</sub></span>
            <b-button
              id="popover-power"
              variant="default"
              tabindex="-1"
            >
              <font-awesome-icon icon="question-circle" />
            </b-button>
            <b-popover
              target="popover-power"
              triggers="hover"
              placement="top"
            >
              <template v-slot:title>
                {{ $t('bearings.powerTooltipHeadline') }}
              </template>
              <p>{{ $t('bearings.powerTooltip') }}</p>
              <!--              <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
            </b-popover>
          </template>
          <b-input-group append="kN">
            <FormInputDecimal
              id="power"
              v-model="power"
              type="text"
              decimal-places="1"
              aria-describedby="popover-power"
            >
            </FormInputDecimal>
          </b-input-group>
        </b-form-group>
      </div>
      <div class="col-sm-6">
        <b-form-group
          label-for="contact-surface"
        >
          <template slot="label">
            {{ $t('bearings.typeContactSurface') }}
            <b-button
              id="popover-contact-surface"
              variant="default"
              tabindex="-1"
            >
              <font-awesome-icon icon="question-circle" />
            </b-button>
            <b-popover
              target="popover-contact-surface"
              triggers="hover"
              placement="top"
              tabindex="-1"
            >
              <template v-slot:title>
                {{ $t('bearings.typeContactSurfaceTooltipHeadline') }}
              </template>
              <p>{{ $t('bearings.typeContactSurfaceTooltip') }}</p>
              <!--              <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
            </b-popover>
          </template>
          <b-input-group>
            <b-form-select
              v-model="typeContactSurface"
              :options="typeContactSurfaceOptions"
            >
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </div>
    </div>
    <div v-if="typeContactSurface === 'concrete'">
      <div class="row">
        <div class="col-sm-6"></div>
        <div class="col-sm-6">
          <b-form-group
            label-for="concrete-quality"
          >
            <template slot="label">
              {{ $t('edgeDistanceEC.concreteQuality') }}
              <b-button
                id="popover-concrete-quality"
                variant="default"
                tabindex="-1"
              >
                <font-awesome-icon icon="question-circle" />
              </b-button>
              <b-popover
                target="popover-concrete-quality"
                triggers="hover"
                placement="top"
              >
                <template v-slot:title>
                  {{ $t('bearings.concreteQualityTooltipHeadline') }}
                </template>
                <p>{{ $t('bearings.concreteQualityTooltip') }}</p>
                <!--              <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
              </b-popover>
            </template>

            <b-input-group>
              <b-form-select
                v-model="concreteType"
                :options="concreteTypeOptions"
              />
            </b-input-group>
          </b-form-group>
        </div>
      </div>
    </div>
    <!-- Auflagerverdrehung -->
    <div class="row">
      <!-- Auflagerverdrehung a -->
      <div class="col-md-6">
        <b-form-group
          label-for="twistingA"
        >
          <template slot="label">
            {{ $t('bearings.twisting') }}
            <span class="text-muted">&alpha; <sub>a,d</sub></span>
            <b-button
              id="popover-twisting-a"
              variant="default"
              tabindex="-1"
            >
              <font-awesome-icon icon="question-circle" />
            </b-button>
            <b-popover
              target="popover-twisting-a"
              triggers="hover"
              placement="top"
            >
              <template v-slot:title>
                {{ $t('bearings.twistingTooltipHeadline') }}
              </template>
              <p>{{ $t('bearings.twistingTooltip',{'site' : 'a'}) }}</p>
              <!--              <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
            </b-popover>
          </template>
          <b-input-group>
            <template v-slot:append>
              <b-input-group-text>&permil;</b-input-group-text>
            </template>
            <FormInputDecimal
              id="twistingA"
              v-model="twistingA"
              type="text"
              decimal-places="2"
            >
            </FormInputDecimal>
          </b-input-group>
        </b-form-group>
      </div>
      <!-- Auflagerverdrehung b -->
      <div class="col-md-6">
        <b-form-group
          label-for="twistingB"
        >
          <template slot="label">
            {{ $t('bearings.twisting') }}
            <span class="text-muted">&alpha; <sub>b,d</sub></span>
            <b-button
              id="popover-twisting-b"
              variant="default"
              tabindex="-1"
            >
              <font-awesome-icon icon="question-circle" />
            </b-button>
            <b-popover
              target="popover-twisting-b"
              triggers="hover"
              placement="top"
            >
              <template v-slot:title>
                {{ $t('bearings.twistingTooltipHeadline') }}
              </template>
              <p>{{ $t('bearings.twistingTooltip',{'site' : 'b'}) }}</p>
              <!--              <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
            </b-popover>
          </template>
          <b-input-group>
            <template v-slot:append>
              <b-input-group-text>&permil;</b-input-group-text>
            </template>
            <FormInputDecimal
              id="twistingB"
              v-model="twistingB"
              type="text"
              decimal-places="2"
            >
            </FormInputDecimal>
          </b-input-group>
        </b-form-group>
      </div>
    </div>
    <!-- Checkbox Verdrehungszuschlag -->
    <div class="row">
      <div class="col-md-6">
        <b-form-checkbox
          id="withTwistSurcharge"
          v-model="twistingWithSurcharge"
          name="withTwistSurcharge"
        >
          {{ $t('bearings.withTwistSurcharge') }}
          <b-button
            id="popover-twist-surcharge"
            variant="default"
            tabindex="-1"
          >
            <font-awesome-icon icon="question-circle" />
          </b-button>
          <b-popover
            target="popover-twist-surcharge"
            triggers="hover"
            placement="top"
          >
            <p>
              {{ $t('bearings.withTwistSurchargeTooltip1') }}
              <strong>
                {{ $t('bearings.withTwistSurchargeTooltip2') }}
              </strong>
            </p>
            <!--          <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
          </b-popover>
        </b-form-checkbox>
      </div>
      <div class="col-6 text-end">
        <span
          class="text-primary help-link"
          role="button"
          @click="openHelpModal"
        >
          {{ $t('bearings.twistingHelp') }}
        </span>
      </div>
    </div>
    <FixedBearingsTwistingHelpModalOutput />
    <!-- Verdrehungszuschlag -->
    <div
      v-if="twistingWithSurcharge"
      class="mt-2"
    >
      <div class="row">
        <!-- Verdrehungszuschlag Schiefwinklig -->
        <div class="col-md-6">
          {{ $t('bearings.twistingSurcharge') }}
          <span class="text-muted">
            &alpha; <sub>{{ $t('bearings.twistingSurchargeAskew') }} </sub>
          </span>
          <span class="text-muted">
            {{ twistingSurchargeAskew | numeralFormat('0.0') }} &permil;
          </span>
        </div>
        <!-- Verdrehungszuschlag Unebenheit -->
        <div class="col-md-6">
          {{ $t('bearings.twistingSurcharge') }}
          <span class="text-muted">
            &alpha; <sub>{{ $t('bearings.twistingSurchargeRoughness') }} </sub>
          </span>
          <span class="text-muted">
            {{ twistingSurchargeRoughness | numeralFormat('0.0') }} &permil;
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FixedBearingsTwistingHelpModalOutput from '@/components/fixedBearings/FixedBearingsTwistingHelpModalOutput.vue';
import FormInputDecimal from '../app/form/FormInputDecimal.vue';

export default {
  name: 'FixedBearingsFormEffects',
  components: {
    FixedBearingsTwistingHelpModalOutput,
    FormInputDecimal,
  },
  data() {
    return {
      twistingSurchargeAskew: 10,
    };
  },
  computed: {
    typeContactSurfaceOptions() {
      return Object.values(this.$dataOptionsHelper.getTypeContactSurfaceOptions(this.$i18n));
    },
    concreteTypeOptions() {
      return Object.values(this.$dataOptionsHelper.getConcreteQualityOptions(this.$i18n));
    },
    twistingSurchargeRoughness() {
      const values = [
        this.twistingA,
        this.twistingB,
        this.$store.state.fixedBearingWidth,
        this.$store.state.fixedBearingLength,
        this.$store.state.fixedBearingThickness,
      ];

      if (!values.every(v => Number.isFinite(Number(v)))) {
        return 0;
      }

      const mainStressedSide = this.$calcHelper.getMainStressedSide(
        Number(this.twistingA),
        Number(this.twistingB),
        Number(this.$store.state.fixedBearingWidth),
        Number(this.$store.state.fixedBearingLength),
        Number(this.$store.state.fixedBearingThickness),
      );

      const surcharge = this.$calcHelper.getSurchargeRoughness(
        mainStressedSide,
        this.typeContactSurface,
      );

      return Number.isFinite(surcharge) ? surcharge : 0;
    },
    power: {
      get() {
        return this.$store.state.fixedBearingPressureForce;
      },
      set(value) {
        this.$store.commit('fixedBearingPressureForce', value);
      },
    },
    twistingA: {
      get() {
        return this.$store.state.fixedBearingTwistingA;
      },
      set(value) {
        this.$store.commit('fixedBearingTwistingA', value);
      },
    },
    twistingB: {
      get() {
        return this.$store.state.fixedBearingTwistingB;
      },
      set(value) {
        this.$store.commit('fixedBearingTwistingB', value);
      },
    },
    twistingWithSurcharge: {
      get() {
        return this.$store.state.fixedBearingTwistingWithSurcharge;
      },
      set(value) {
        this.$store.commit('fixedBearingTwistingWithSurcharge', value);
      },
    },
    typeContactSurface: {
      get() {
        return this.$store.state.fixedBearingTypeContactSurface;
      },
      set(value) {
        this.$store.commit('fixedBearingTypeContactSurface', value);
      },
    },
    concreteType: {
      get() {
        return this.$store.state.fixedBearingConcreteType;
      },
      set(value) {
        this.$store.commit('fixedBearingConcreteType', value);
      },
    },
  },
  watch: {
    typeContactSurface(newVal) {
      if (newVal !== 'Beton') {
        this.concreteType = null;
      }
    },
  },
  methods: {
    openHelpModal() {
      this.$bvModal.show('twistingHelpModalOutput');
    },
  },
};
</script>

<style scoped lang="scss">
.help-link {
  cursor: pointer;
  text-decoration: underline;
}
</style>
